// captains
export const CAPTAIN_A = 'A';
export const CAPTAIN_C = 'C';

// positions
export const POSITION_HEAD_COACH         = 'HC';
export const POSITION_ASSISTANT_COACH    = 'AC';
export const POSITION_TEAM_MANAGER       = 'TM';
export const POSITION_DRIVER             = 'DV';
export const POSITION_MEDICAL_STAFF      = 'MS';
export const POSITION_EQUIPMENT_MANAGER  = 'EQ';
export const POSITION_GOALKEEPER         = 'G';
export const POSITION_DEFENDER           = 'D';
export const POSITION_LEFT_DEFENDER      = 'LD';
export const POSITION_RIGHT_DEFENDER     = 'RD';
export const POSITION_FORWARD            = 'F';
export const POSITION_LEFT_FORWARD       = 'LF';
export const POSITION_RIGHT_FORWARD      = 'RF';
export const POSITION_CENTER             = 'C';
export const POSITION_ALL_PLAYERS        = '_PLAYERS';
export const POSITION_ALL_TEAM_OFFICIALS = '_TEAMOFFICIALS';

// suspension settings
export const SUSPENSION_SETTING_DENY  = 'DENY';